<template>
  <div class="nav-container">
    <div class="linkcard">
      <router-link
        class="link"
        :class="current == link.key && 'actived'"
        v-for="link in links"
        :key="link.key"
        :to="`/?s=${link.key}`"
        >{{ link.val }}</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: [
        { key: "1", val: "女性時尚" },
        { key: "2", val: "男性時尚" },
        { key: "3", val: "旅遊飲食" },
        { key: "4", val: "商業職場" },
        { key: "5", val: "時事財經" },
        { key: "6", val: "心靈勵志" },
        { key: "7", val: "保健養生" },
        { key: "8", val: "汽車科技" },
        // { key: "9", val: "攝影藝術" },
        { key: "10", val: "空間建築" },
        { key: "11", val: "語言學習" },
        { key: "12", val: "興趣品味" },
      ],
    };
  },
  computed: {
    current() {
      return this.$route.query.s;
    },
  },
};
</script>

<style scoped>
.nav-container {
  background-color: white;
  display: flex;
  flex-wrap: wrap;
}

.linkcard {
  margin: 0.1rem;
  /* min-width: 2.26rem; */
  /* border-bottom: 1px solid #474747; */
}

.link {
  display: block;
  /* border-bottom: 1px solid #474747; */
  color: #474747;
  font-size: 0.18rem;
  line-height: 0.18rem;
  margin: 0.1rem 0;
  width: 1.2rem;
  padding: 5px;
  text-align: center;
}

.actived {
  background-color: rgb(239, 239, 239);
  border-radius: 5px;
}

.link:last-child {
  border-bottom: none;
}
</style>